module.exports = __webpack_public_path__ + "img/2340.abec4661.jpg";